export default class PromiseReducer {
    static all(promises) {
        return Promise.all(promises).then((p) => p.reduce((p1, p2) => p1 && p2, true));
    }
}
